class DesktopMenu {
  constructor() {
    this.menu = document.querySelector('.navMain');
    this.menuOpen = false;
    this.subMenuOpen = false;
    this.currentMenu;
    this.menuItems = document.querySelectorAll('.navMain > .menu-item-has-children > .navMain__submenu > .navMain__item');

    if (window.innerWidth >= 1140) {
      this.events();
    }
  }

  events() {

    document.addEventListener('click', ev => {
      if (ev.target.closest('li') && ev.target.closest('li').offsetParent == this.menu) {
        if (this.menuOpen) {
          this.menuOpen = false;
          this.hideMenu();
          this.currentMenu.classList.remove('navMain__item--open');
          this.subMenu.classList.remove('navMain__item--open');
        } else {
          this.menuOpen = true;
          if (ev.target.closest('li').classList.contains('menu-item-has-children')) {
            this.currentMenu = ev.target.closest('li');
            this.subMenu = this.currentMenu.querySelector('.navMain__submenu');
            this.currentMenu.classList.add('navMain__item--open');
            this.subMenu.classList.add('navMain__submenu--open');
            this.subMenuOpen = true;
          }
        }
        if (ev.target.closest('li') !== this.currentMenu) {
          this.currentMenu.classList.remove('navMain__item--open');
          this.subMenu.classList.remove('navMain__submenu--open');
          this.currentMenu = ev.target.closest('li');
          this.subMenu = this.currentMenu.querySelector('.navMain__submenu');
          this.currentMenu.classList.add('navMain__item--open');
          this.subMenu.classList.add('navMain__submenu--open');
          this.menuOpen = true;
        }
      } else if (ev.target.closest('li') && ev.target.closest('li').offsetParent.classList.contains('navMain__submenu--open')) {
        if (ev.target.closest('li').querySelector('.navMain__submenu') == this.subMenu) {
          if (this.subMenuOpen) {
            this.fadeInAllItems();
            this.subMenuOpen = false;
            this.subMenu.classList.remove('navMain__submenu--open');
          } else {
            this.fadeItemsExcept(ev.target.closest('li'));
            this.subMenu.classList.add('navMain__submenu--open')
            this.subMenuOpen = true;
          }
          return;
        }

        this.hideSubMenus();
        let currentItem = ev.target.closest('li');
        this.subMenu = currentItem.querySelector('.navMain__submenu');
        this.subMenu.classList.toggle('navMain__submenu--open');
        this.fadeInAllItems();
        this.fadeItemsExcept(currentItem);

      } else {
        this.menuOpen = false;
        this.subMenuOpen = false;
        if (this.currentMenu) {
          this.currentMenu.classList.remove('navMain__item--open');
        }
        if (this.subMenu) {
          this.subMenu.classList.remove('navMain__submenu--open');
        }
        this.hideSubMenus();
        this.hideMenu();
        this.fadeInAllItems();
      }

    });
  }

  hideSubMenus() {
    let allSubMenus = document.querySelectorAll('.navMain .menu-item-has-children .navMain__submenu .menu-item-has-children .navMain__submenu');
    allSubMenus.forEach(menu => {
      menu.classList.remove('navMain__submenu--open');
    });
  }

  hideMenu() {
    let allMenus = document.querySelectorAll('.navMain .menu-item-has-children .navMain__submenu');
    allMenus.forEach(menu => {
      menu.classList.remove('navMain__submenu--open');
    })
  }

  fadeInAllItems() {
    this.menuItems.forEach(li => {
      li.classList.remove('navMain__item--fade');
      li.classList.remove('navMain__item--current');
    })
  }

  fadeItemsExcept(current) {
    let menuItems = document.querySelectorAll('.navMain > .menu-item-has-children > .navMain__submenu--open > .navMain__item');
    menuItems.forEach(li => {
      if (li !== current) {
        li.classList.add('navMain__item--fade');
        li.classList.remove('navMain__item--current');
      }
    });
    current.classList.add('navMain__item--current');
  }


}

export default DesktopMenu;